module.exports = __webpack_public_path__ + "img/Gemse.1e2e5894.svg";